import { render, staticRenderFns } from "./ConsignacaoList.vue?vue&type=template&id=51891cae&scoped=true&"
import script from "./ConsignacaoList.vue?vue&type=script&lang=js&"
export * from "./ConsignacaoList.vue?vue&type=script&lang=js&"
import style0 from "./ConsignacaoList.vue?vue&type=style&index=0&id=51891cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51891cae",
  null
  
)

export default component.exports